import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import $ from 'jquery';
import Ajax from '../ajax/Ajax';

class Joe extends Component {
	
	constructor(props) {
		super(props);
		this.state = {box: {}, sorted: false};
		this.addItem = this.addItem.bind(this);
		this.updateItem = this.updateItem.bind(this);
		this.update = this.update.bind(this);
		this.sortItems = this.sortItems.bind(this);
	}
	
	componentWillMount() {
		var obj = this;
		Ajax.getJoe().then(function(items) {
			var keysSorted = Object.keys(items).sort(
				function(a, b) {
					return (items[a]["name"].toLowerCase() < items[b]["name"].toLowerCase() ? -1 : 1);
				}
			);
			obj.setState({items: items, sorted: keysSorted});
		});
	}
	
	sortItems(field) {
		var obj = this;
		return function(event) {
			var list = obj.state.items;
			var keysSorted = Object.keys(list).sort(
				function(a, b) {
					return (list[a][field].toLowerCase() < list[b][field].toLowerCase() ? -1 : 1);
				}
			);
			obj.setState({sorted: keysSorted});
		}
	}
	
	update(items) {
		var obj = this;
		Ajax.postJoe(items).then(function () {
			obj.setState({items: items});
		});		
	}
	
	addItem(event) {
		var obj = this;
		Ajax.getJoe().then(function (items) {
			var id = (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase();
			var item = {
					name: "",
					description: "",			
					origin: "",
					price: ""
				}
			items[id] = item;	
			var keysSorted = Object.keys(items).sort(
					function(a, b) {
						return (items[a]["name"].toLowerCase() < items[b]["name"].toLowerCase() ? -1 : 1);
					}
				);
			obj.setState({items: items, sorted: keysSorted});
			obj.update(items);
		});		
	}
	
	updateItem(id) {
		var obj = this;
		
		return function(event) {
			Ajax.getJoe().then(function (items) {
				var el = $("#" + id);
				var name = $(".JoeItemName", el).first()[0].innerHTML;
				var description = $(".JoeItemDescription", el).first()[0].innerHTML;
				var origin = $(".JoeItemOrigin", el).first()[0].innerHTML;
				var price = $(".JoeItemPrice", el).first()[0].innerHTML;
				var item = {
					name: name,
					description: description,			
					origin: origin,
					price: price
				}
				
				items[id] = item;
				obj.setState({items: items});
				obj.update(items);
			});
		};
	}
	
	render() {
		var items = this.state.items;
		var sorted = this.state.sorted;
		var obj = this;
		
		return (
		<div className="Joe">
			<div className="JoeImage" />
			<div className="TextBox">
				<p>Chez Joe on trouve tout ce qu'un aventurier pourrait avoir besoin. Tous les objets non magiques du Manuel des Joueurs sont disponibles chez Joe, mis à part les armures de plates, qui elles doivent être commandées.</p>
				<p>Joe revend aussi certains objets magiques trouvés dans les ruines par les aventuriers, du moins si le prochain bateau n'est pas encore arrivé...</p>
			</div>
			
			<div className="ItemList">
				<div className="ItemListHeaders">					
					<div className="ItemListHeader JoeItemName" onClick={this.sortItems("name")}>Objet</div>
					<div className="ItemListHeader JoeItemDescription" onClick={this.sortItems("description")}>Description</div>
					<div className="ItemListHeader JoeItemOrigin" onClick={this.sortItems("origin")}>Origine</div>
					<div className="ItemListHeader JoeItemPrice" onClick={this.sortItems("origin")}>Prix</div>
				</div>
				<div className="AddSymbol" onClick={this.addItem}><FontAwesomeIcon icon="shopping-cart"/><FontAwesomeIcon icon="plus"/></div>
				
				{items && sorted ? 
				
				sorted.map(function(key, idx) {
					var item = items[key];
					return (
					<div id={key} key={idx} className="Item">
						<div className="ItemField JoeItemName" contentEditable="true" onBlur={obj.updateItem(key)} dangerouslySetInnerHTML={{__html: item.name}}></div>
						<div className="ItemField JoeItemDescription" contentEditable="true" onBlur={obj.updateItem(key)} dangerouslySetInnerHTML={{__html: item.description}}></div>
						<div className="ItemField JoeItemOrigin" contentEditable="true" onBlur={obj.updateItem(key)} dangerouslySetInnerHTML={{__html: item.origin}}></div>
						<div className="ItemField JoeItemPrice" contentEditable="true" onBlur={obj.updateItem(key)} dangerouslySetInnerHTML={{__html: item.price}}></div>
					</div>
					)
				}): null
				}
				
			</div>        
		</div>
		);
	}
}

export default Joe;



// WEBPACK FOOTER //
// ./src/components/Joe.js